import Layout from "@/components/Layout";
import { ROUTE_NAMES, ROUTE_PATHS } from "@/router/constants";
import Dashboard from "@/views/Dashboard";
import ComplianceReview from "@/views/ComplianceReview";
import ComplianceReviewSearch from "@/views/ComplianceReviewSearch";
import ComplianceReviewDetails from "@/views/ComplianceReviewDetails";
import Identification from "@/views/Identification";
import Screening from "@/views/Screening";
import SanctionSearch from "@/views/SanctionSearch";
import SanctionDetails from "@/views/SanctionDetails";
import Login from "@/views/Login";
import NotFoundPage from "@/views/NotFoundPage";
import SignInCallback from "@/views/SignInCallback";
import SilentCallback from "@/views/SilentCallback";
import SignOutCallback from "@/views/SignOutCallback";
import StatusPage from "@/views/StatusPage";
import TypeGame from "@/views/TypeGame";

export default [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        redirect: { name: ROUTE_NAMES.IDENTIFICATION },
        meta: { requiresAuth: true }
      },
      {
        path: "dashboard",
        name: ROUTE_NAMES.DASHBOARD,
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: "identification",
        name: ROUTE_NAMES.IDENTIFICATION,
        component: Identification,
        meta: { requiresAuth: true }
      },
      {
        path: "compliance-review",
        component: ComplianceReview,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: ROUTE_NAMES.COMPLIANCE_REVIEW_SEARCH,
            component: ComplianceReviewSearch,
            meta: { requiresAuth: true }
          },
          {
            path: "identification",
            name: ROUTE_NAMES.COMPLIANCE_REVIEW_DETAILS,
            component: ComplianceReviewDetails,
            meta: { requiresAuth: true },
            props: route => ({
              query: [route.query.id, route.query.identificationId]
            })
          }
        ]
      },
      {
        path: "screening",
        component: Screening,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: ROUTE_NAMES.SANCTION_SEARCH,
            component: SanctionSearch,
            meta: { requiresAuth: true }
          },
          {
            path: `sanction/:id`,
            name: ROUTE_NAMES.SANCTION_DETAILS,
            component: SanctionDetails,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: "typeGame",
        name: ROUTE_NAMES.TYPE_GAME,
        component: TypeGame,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: `/${ROUTE_PATHS.STATUS}`,
    name: ROUTE_NAMES.STATUS,
    component: StatusPage
  },
  {
    path: `/${ROUTE_PATHS.SIGN_IN_CALLBACK}`,
    name: ROUTE_NAMES.SIGN_IN_CALLBACK,
    component: SignInCallback
  },
  {
    path: `/${ROUTE_PATHS.SILENT_CALLBACK}`,
    name: ROUTE_NAMES.SILENT_CALLBACK,
    component: SilentCallback
  },
  {
    path: `/${ROUTE_PATHS.SIGN_OUT_CALLBACK}`,
    name: ROUTE_NAMES.SIGN_OUT_CALLBACK,
    component: SignOutCallback
  },
  {
    path: `/login`,
    name: ROUTE_NAMES.LOGIN,
    component: Login
  },
  {
    path: "*",
    component: NotFoundPage
  }
];
